import React from 'react';
import './Class.css';
import vedic from '../../Images/Vedic Math.png';
import {Helmet} from "react-helmet";

const VedicMath = () => (
  <div className="explore-container">
    <Helmet>
                <meta charSet="utf-8" />
                <title>Gurukul Gaint - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
    {/* Back Button */}
    <button className="back-button" onClick={() => window.history.back()}>
      ← Back
    </button>

    {/* Lakshya Card (Right Side, Above Header) */}
    <div className="lakshya-card">
      <img
        src={vedic} 
        loading="lazy"
        alt="bolo-bindass"
        className="lakshya-image"
      />
      <div className="course-details">
  
  <p className="pricing">💼 Fees for Full Course: ₹ 2999/-</p>
  <a href="https://rzp.io/rzp/GurukulGanit" target="_blank" rel="noopener noreferrer">
    <button className="buy-button">Buy Now</button>
  </a>
</div>

    </div>

    {/* Lakshya Header (Full Width) */}
    <div className="lakshya-header">
      <div className="lakshya-header-content">
        <h2 className="lakshya-title">Gurukul <span className='highlight'>Ganit</span> (Class-<span className='highlight'>1-6</span>)</h2>
      </div>
    </div>

    {/* Batch Details Section */}
    <div className="batch-details">
      <h3>Description</h3>
      <ul>
  <li><strong>1️⃣Vedic Math Techniques</strong>  
    <ul>
      <li>🔢Covering foundational math operations, fractions, percentages, and more using ancient yet modern methods.
      </li>
    </ul>
  </li>
  <li><strong>2️⃣Faster Calculations</strong>  
    <ul>
      <li>⏳Learn shortcuts that reduce time in solving problems, especially useful for competitive exams.
      </li>
    </ul>
  </li>
  <li><strong>3️⃣Mental Math Practice</strong>  
    <ul>
      <li>🧠Develop mental agility by solving problems without pen and paper.
      </li>
    </ul>
  </li>
  <li><strong>4️⃣Accuracy & Speed</strong>  
    <ul>
      <li>📊Improve not only speed but also accuracy in math calculations.
      </li>
    </ul>
  </li>
  <li><strong>5️⃣Step-by-Step Instruction</strong>  
    <ul>
      <li>🧑‍🏫Easy explanations ensure every student grasps the techniques effortlessly.</li>
    </ul>
  </li>
  <li><strong>6️⃣Gamified Learning</strong>  
    <ul>
      <li>🎮Enjoy quizzes, puzzles, and challenges to reinforce skills.
      </li>
    </ul>
  </li>
  <li><strong>7️⃣Weekly Assessments</strong>  
    <ul>
      <li>🏆Regular assignments and feedback ensure continuous improvement.
      </li>
    </ul>
  </li>
  <li><strong>8️⃣Confidence Building</strong>  
    <ul>
      <li>🌟Empower students to approach math fearlessly in school and beyond.
      </li>
    </ul>
  </li>
  <li><strong>9️⃣24/7 Doubt Solving</strong>  
    <ul>
      <li>🧑‍💻Get help anytime with your doubts through 24/7 doubt-solving support.
      </li>
    </ul>
  </li>
  <li><strong>🔟Free Study Material</strong>  
    <ul>
      <li>📧Get practice sheets and a guidebook to perfect your skills.
      </li>
    </ul>
  </li>
  <li><strong>📩 Have Questions?</strong>  
    <ul>
      <li>Reach out to us at <a href="mailto:support@ottertutors.com">support@ottertutors.com</a></li>
    </ul>
  </li>
  <br/>
  <li><strong>🚀 Join <span className='highlight1'>'Gurukul Gaint'</span> Take the first step towards academic success!</strong>  
  </li>
</ul>


    </div>

    {/* FAQ Section */}
    <div className="faq-section">
      <h2>FAQs</h2>
      <p style={{ textAlign: 'center' }}>
  Here are some of the frequently asked questions:
</p>
<div className="faq-grid">
  <div className="faq-item">
    🎯
    <div>
      <h3>Who Should Join This Batch?</h3>
      <p>
      🎓 Class 1-6 students who want to enhance their math skills and learn faster, smarter ways to solve problems.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Where Will the Classes Be Held?</h3>
      <p>
        💻 Classes will be conducted on Zoom, and links will be shared via WhatsApp groups for easy access.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>What Is the Duration of Each Class?</h3>
      <p>
      ⏳ Each class is 1 hour long, ensuring enough time for learning and practice.      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>What If My Child Misses a Class?</h3>
      <p>
      📼 All classes are recorded, so students can revisit or catch up on missed lessons anytime.      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>What Topics Are Covered in Vedic Maths?</h3>
      <p>
      🧮 We cover addition, subtraction, multiplication, division, fractions, and percentages, along with shortcuts for each.      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Will Vedic Maths Replace School Math?</h3>
      <p>
      📝 Not at all! Vedic Maths complements school math by offering quicker and smarter ways to solve problems, reinforcing regular math concepts.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Can I Get Help If I Have Doubts?</h3>
      <p>
      💡 Yes! Our 24/7 doubt-solving support ensures students get assistance anytime.      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>How Will My Child’s Progress Be Tracked?</h3>
      <p>
      📊 Weekly tests and assignments are conducted, with detailed feedback provided to improve performance.      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>Can I Get a Refund After Batch Purchase?</h3>
      <p>
      💬 Refunds are not available post-purchase due to the resources invested in delivering high-quality education. Please make an informed decision.
      </p>
    </div>
  </div>
  <div className="faq-item">
    🎯
    <div>
      <h3>How Can Vedic Maths Help My Child Long-Term?</h3>
      <p>
      🌟 Vedic Maths enhances mental agility, speed, and confidence, making math enjoyable and preparing students for higher-level problem-solving in academics and competitive exams.
      </p>
    </div>
  </div>
</div>
</div>
  </div>
);

export default VedicMath;
